// @flow
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@shared/Button';
import { DonationOverlay } from './DonationOverlay';

const DONATION_URLS = {
  es: 'https://soutenir.sielbleu.org/es/donar/?capsule=donner',
  fr: 'https://soutenir.sielbleu.org/donner/?capsule=donner',
};

export default function DonationFloatingButton(): React$Node {
  const { t, i18n } = useTranslation();
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const lang = i18n.language?.split('-')[0];
  const baseUrl = new URL(DONATION_URLS[lang] ?? DONATION_URLS.fr);
  baseUrl.searchParams.set('utm_source', 'mcsb');
  const donationUrl = baseUrl.toString();

  return (
    <>
      <div className="donation-floating-button">
        <Button className="donation-floating-button__btn" onClick={ () => setIsOverlayOpen(true) }>
          { t('donation.button') }
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="#134E9E"
            aria-hidden="true"
          >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
        </Button>
      </div>

      <DonationOverlay isOpen={ isOverlayOpen } onClose={ () => setIsOverlayOpen(false) } url={ donationUrl } />
    </>
  );
}
